<script lang="ts">
	//Svelte
	import { createEventDispatcher } from 'svelte';
	import { push, location } from 'svelte-spa-router';
	//Helpers
	import { _deepClone } from '../../../helpers/utilities';
	import { alarm_object_prototype } from 'src/components/AlarmZones/AlarmWizard/alarm_object';
	//Components
	import AlarmWizard from 'src/components/AlarmZones/AlarmWizard/AlarmWizard.svelte';

	export let showModal: boolean;

	const ALL_ALARMS_ROUTE = '/home/alarms/-1';
	let alarm_id;
	let alarm_object = _deepClone(alarm_object_prototype);

	const onAlarmSaved = () => {
		//Redirect to all alarms after create new
		if (!$location.includes(ALL_ALARMS_ROUTE)) {
			push(ALL_ALARMS_ROUTE);
		}
	};
</script>

<AlarmWizard
	bind:id={alarm_id}
	bind:showAddEditAlarmModal={showModal}
	bind:alarm_object
	on:alarm-saved={onAlarmSaved}
	on:close
/>
